import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { MiList } from "@miplatform/components";
import { ENTITY_NAMES } from "@miplatform/constants";
import { IWorkOrderTemplate } from "@miplatform/types";
import { ConfigCard } from "../../components";
import { ConfigAccordionHeader } from "../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { IOrderTemplateForm } from "../ConfigOrderTemplates.types";

export const OrderWorkOrderTemplatesTabView: FC<
  OrderWorkOrderTemplatesTabViewProps
> = ({ form }) => {
  const { watch } = form;
  const { workOrderTemplates } = watch();

  return (
    <ConfigAccordionHeader title={ENTITY_NAMES.WORK_ORDER_TEMPLATES}>
      <MiList
        viewType="card"
        data={workOrderTemplates}
        hideListPagination
        CardComponent={ConfigWorkOrderTemplateCard}
        emptyListProps={{
          text: `No ${ENTITY_NAMES.WORK_ORDER_TEMPLATES} found`,
        }}
      />
    </ConfigAccordionHeader>
  );
};

const ConfigWorkOrderTemplateCard = ({
  item,
}: {
  item: IWorkOrderTemplate;
}) => {
  const { name, modifiedOn } = item;

  return <ConfigCard title={name} modifiedOn={modifiedOn} />;
};

interface OrderWorkOrderTemplatesTabViewProps {
  form: UseFormReturn<IOrderTemplateForm>;
}
